<template>
  <div class="resignation">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">
                  Manual Salary Item
                </h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Salary</li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto">
                <a class="btn add-btn" @click="() => { dialogDelete = true }" v-if="salaries.length > 0"
                  ><i class="fa fa-plus"></i> Submit To Process</a
                >
                
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header">
                <h5 class="modal-title">Add Manual Pay Item</h5>
            </div>
            <div class="row card-body">
              <div class="form-group col-md-2">
                    <label>Employee <span class="text-danger">*</span></label>
                    <multiselectvue
                    class="from-control"
                    v-model="employee"
                    placeholder="Select Employee"
                    :custom-label="nameOfEmployee"
                    :options="sortedEmployees"
                    :searchable="true"
                    @select="optionSelectedEmployee"
                    :allow-empty="false"
                  >
                    <template slot="singleLabel" slot-scope="{ option }"
                      >{{ option.firstName + ' ' + option.lastName }}
                    </template>
                  </multiselectvue>
                  </div>
            <div class="form-group col-md-2">
                    <label>Element <span class="text-danger">*</span></label>
                  <multiselectvue
                    class="from-control"
                    v-model="element"
                    placeholder="Select Salary Element"
                    :custom-label="nameOfSalaryElement"
                    :options="sortedSalayElements"
                    :searchable="true"
                    @select="optionSelectedSalaryElement"
                    :allow-empty="false"
                  >
                    <template slot="singleLabel" slot-scope="{ option }"
                      >{{ option.description }}
                    </template>
                  </multiselectvue>
                  </div>
                  <div class="form-group col-md-2">
                    <label>Amount <span class="text-danger">*</span></label>
                    <input
                      v-model="amount"
                      class="form-control"
                      type="number"
                    />
                  </div>
                  <div class="form-group col-md-2">
                    <label
                    >Variable Start Date <span class="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    class="form-control"
                    name=""
                    id=""
                    v-model="variableStartDate"
                  />
                  </div>
                  <div class="form-group col-md-2">
                    <label>Duration <span class="text-danger">*</span></label>
                  <select
                    class="form-control"
                    v-model="month"
                    @change="calculateLoanMonths"
                    
                  >
                    <option value="0">1 Month</option>
                    <option value="1">2 Months</option>
                    <option value="2">3 Months</option>
                    <option value="3">4 Months</option>
                    <option value="4">5 Months</option>
                    <option value="5">6 Months</option>
                    <option value="6">7 Months</option>
                    <option value="7">8 Months</option>
                    <option value="8">9 Months</option>
                    <option value="9">10 Months</option>
                    <option value="10">11 Months</option>
                    <option value="11">12 Months</option>
                  </select>
                  </div>
                  <div class="form-group col-md-2">
                    <label
                    >Variable End Date <span class="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    class="form-control"
                    name=""
                    id=""
                    v-model="variableEndDate"
                  />
                  </div>
                  <div class="submit-section col-md- 3">
                    <button class="btn btn-secondary" @click="addSalary">Add</button>
                  </div>
            </div>
          </div>
          <!-- /Page Header -->
          <!----Datatable-->
          <div class="row">
            <div class="col-md-12">
              <div class="table-responsive">
                <v-data-table
                  :headers="headers"
                  :items="salaries"
                  :item-class="
                    item =>
                      item.salaryElement.categoryId == 2 ? 'red' : 'green'
                  "
                  sort-by=""
                  class="elevation-1"
                >
                  <template v-slot:[`item.actions`]="{ item }">
                    <div class="dropdown dropdown-action">
                      <a
                        href="#"
                        class="action-icon dropdown-toggle"
                        data-toggle="dropdown"
                        aria-expanded="false"
                        ><i class="material-icons">more_vert</i></a
                      >
                      <div class="dropdown-menu dropdown-menu-right">
                        <a class="dropdown-item" @click="removeline(item)"
                          ><i class="fa fa-trash-o m-r-5"></i> Remove</a
                        >
                      </div>
                    </div>
                  </template>
                  <template v-slot:[`item.profile`]="{ item }">
                    <h2 class="table-avatar blue-link">
                      <router-link to="/profile" class="avatar"
                        ><img alt="" src="~@/assets/profiles/avatar-02.jpg"
                      /></router-link>
                      <router-link to="/profile">{{
                        `${item.employee.firstName} ${item.employee.lastName}`
                      }}</router-link>
                    </h2>
                  </template>
                  <template v-slot:[`item.frequency`]="{ item }">
                    {{
                      item.salaryElement.frequency == 1 ? "Monthly" : "Variable"
                    }}
                  </template>
                  <template v-slot:[`item.thirteenMonth`]="{ item }">
                    {{ item.thirteenMonth ? "Yes" : "No" }}
                  </template>
                  <template v-slot:[`item.amount`]="{ item }">
                    {{
                      item.amount
                        .toFixed(2)
                        .toString()
                        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                    }}
                  </template>
                  <template v-slot:[`item.variableStartDate`]="{ item }">
                    {{
                      item.variableStartDate
                        ? new Date(item.variableStartDate).toLocaleDateString()
                        : ""
                    }}
                  </template>
                  <template v-slot:[`item.variableEndDate`]="{ item }">
                    {{
                      item.variableEndDate
                        ? new Date(item.variableEndDate).toLocaleDateString()
                        : ""
                    }}
                  </template>
                </v-data-table>
              </div>
            </div>
          </div>
          <!---/Datatable-->
          <v-dialog v-model="dialogDelete" max-width="500px">
            <div class="modal-content">
              <div class="modal-body">
                <div class="form-header">
                  <button type="button" class="close" @click="closeDelete">
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <h3>Confirm Submit</h3>
                  <p>Do you want to recalculate tax at same time?</p>
                </div>
                <div class="modal-btn delete-action">
                  <div class="row">
                    <div class="col-6" v-if="!submitted">
                      <a
                        class="btn btn-primary continue-btn"
                        @click="onSubmit(true)"
                        data-dismiss="modal"
                        >Yes, Recalculate it</a
                      >
                    </div>
                    <div class="col-6" v-if="!submitted">
                      <a
                        href="javascript:void(0);"
                        data-dismiss="modal"
                        @click="onSubmit(false)"
                        class="btn btn-primary cancel-btn"
                        >No, Just submit</a
                      >
                    </div>
                    <div class="col-12" v-if="submitted">
                      <a class="btn add-btn btn-secondary"
                      ><i class="fa fa-plus"></i> Submitting... </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-dialog>
        </div>
        <!-- /Page Content -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import { required, sameAs } from "vuelidate/lib/validators";
import { employeeService } from "@/services/employeeService.js";
import Datepicker from "vuejs-datepicker";
import { authenticationService } from "@/services/authenticationService";
import { organizationService } from "@/services/organizationService";
import { paymentService } from "@/services/paymentService";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Datepicker
  },

  data() {
    return {
      dialog: false,
      dialogEdit: false,
      dialogDelete: false,
      dialogRemoveProrated: false,
      dialogGSlip: false,
      deductions: 0,
      earninng: 0,
      Pearninng: 0,
      reliefs: 0,
      pensionEE: 0,
      pensionER: 0,
      employees: [],
      employee: {},
      tax: 0,
      password: "",
      salaryPayDay: null,
      today: new Date().getDate(),
      headers: [
        { text: "Employee", value: "profile" },
        {
          text: "Name",
          align: "start",
          value: "salaryElement.description"
        },
        { text: "Category", value: "salaryElement.salaryCategory.name" },
        { text: "Amount", value: "amount" },
        { text: "13th Month", value: "thirteenMonth" },
        { text: "Frequency", value: "frequency" },
        { text: "Variable StartDate", value: "variableStartDate" },
        { text: "Variable EndDate", value: "variableEndDate" },
        { text: "Actions", value: "actions", sortable: false }
      ],
      amount: "0",
      thirteenMonth: false,
      startDate: "",
      variableStartDate: "",
      variableEndDate: "",
      endDate: "",
      month: "",
      elements: [],
      salaries: [],
      salary: {
        salaryElement: {}
      },
      prorated: {
        id: 0,
        noOfDayInMonth: 0,
        noOfWorkedDay: 0,
        employeeId: 0
      },
      employee: {},
      element: {},
      loading: false,
      error: "",
      submitted: false,
      //employee: authenticationService.currentOfficeValue,
      company: authenticationService.currentOfficeValue,
      message: null,
      salaryElement: null,
      basicPay: 0
    };
  },

  computed: {
    sortedSalayElements: function() {
      function compare(a, b) {
        if (a.description.toLowerCase() < b.description.toLowerCase())
          return -1;
        if (a.description.toLowerCase() > b.description.toLowerCase()) return 1;
        return 0;
      }

      return this.elements ? this.elements.sort(compare) : this.elements;
    },
    sortedEmployees: function() {
      function compare(a, b) {
        if (a.firstName.toLowerCase() < b.firstName.toLowerCase())
          return -1;
        if (a.firstName.toLowerCase() > b.firstName.toLowerCase()) return 1;
        return 0;
      }

      return this.employees ? this.employees.sort(compare) : this.employees;
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    dialogEdit(val) {
      val || this.closeEdit();
    },
    dialogGSlip(val) {
      val || this.closeGSlip();
    },
    dialogRemoveProrated(val) {
      val || this.closeReview();
    },
    element(val) {
      // set pension
      if (val.subCategoryId == 4) {
        this.amount = (this.Pearninng * 8) / 100;
      }

      //set Tax
      if (val.subCategoryId == 3) {
        this.amount = this.calculateTax(this.earninng, this.pensionEE);
      }

      if (val.subCategoryId == 5) {
        this.amount = (this.Pearninng * 10) / 100;
      }

      // set NHF

      if (val.subCategoryId == 15) {
        this.amount = (this.basicPay * 2.5) / 100;
      }
      // set Pension Employers Contribution

      if (val.subCategoryId == 9) {
        this.amount = (this.Pearninng * 10) / 100;
      }
    }
  },
  methods: {
    removeline(item) {
      var index = this.salaries.findIndex(i => i == item);
      this.salaries.splice(index, 1)
    },
    nameOfEmployee({ firstName, lastName }) {
      return `${firstName} ${lastName}`;
    },
    optionSelectedEmployee(option, id) {
      console.log(option);
      this.employee = option;
    },
    nameOfSalaryElement({ description }) {
      return `${description}`;
    },

    optionSelectedSalaryElement(option, id) {
      console.log(option);
      this.element = option;
    },

    openDialogGSlip() {
      this.dialogGSlip = true;
    },
    openDialogRemoveProrated() {
      this.dialogRemoveProrated = true;
    },

    clearModel() {
      this.element = {};
      this.amount = "0";
      this.thirteenMonth = false;
      this.submitted = false
      this.startDate = "";
      this.endDate = "";
      this.month = "";
      this.salaryElement = [];
    },

    calculateTax(earning, pf) {
      var annualSalary = parseInt(earning) * 12;
      var annualPension = parseInt(pf) * 12;
      var CRA = 200000 + (20 * annualSalary) / 100;
      var taxable = annualSalary - (annualPension + CRA);
      var first300 = (7 * 300000) / 100;
      taxable = taxable - 300000;
      taxable = taxable < 0 ? 0 : taxable;
      var next300 =
        taxable >= 300000 ? (11 * 300000) / 100 : (11 * taxable) / 100;
      taxable = taxable - 300000;
      taxable = taxable < 0 ? 0 : taxable;
      var next500 =
        taxable >= 500000 ? (15 * 500000) / 100 : (15 * taxable) / 100;
      taxable = taxable - 500000;
      taxable = taxable < 0 ? 0 : taxable;
      var _next500 =
        taxable >= 500000 ? (19 * 500000) / 100 : (19 * taxable) / 100;
      taxable = taxable - 500000;
      taxable = taxable < 0 ? 0 : taxable;
      var next1600 =
        taxable >= 1600000 ? (21 * 1600000) / 100 : (21 * taxable) / 100;
      taxable = taxable - 1600000;
      taxable = taxable < 0 ? 0 : taxable;
      var next3200 =
        taxable == 3200000 ? (24 * 3200000) / 100 : (24 * taxable) / 100;
      var annualtax =
        first300 + next300 + next500 + _next500 + next1600 + next3200;
      return annualtax / 12;
    },

    getElements() {
      const companyId = this.company.id;
      paymentService.getSalaryElements(companyId).then(
        model => {
          this.elements = model.filter(x => x.frequency === 2);
          console.log(model);
        },
        error => {
          error = error;
        }
      );
    },
    getEmployees() {
      var unit = JSON.parse(localStorage.getItem("companyUnit"));
      console.log(unit.id);
      employeeService.getEmployees(unit.id).then(
        model => {
          this.employees = model;
          // console.log(model);
        },
        error => {
          error = error;
        }
      );
    },
    openDialog() {
      this.dialog = true;
      console.log(this.salaryPayDay);
    },
    close() {
      this.dialog = false;
      this.clearModel();
    },
    closeEdit() {
      this.dialogEdit = false;
    },
    closeDelete() {
      this.dialogDelete = false;
    },
    closeGSlip() {
      this.dialogGSlip = false;
    },
    closeRemoveProrated() {
      this.dialogRemoveProrated = false;
    },
    setEdit(m) {
      this.salary = m;
      this.dialogEdit = true;
    },
    setDelete(model) {
      this.salary = model;
      this.dialogDelete = true;
    },

    calculateLoanMonths() {
      let selectedMonth = Number(this.month);

      let startDate = moment(this.variableStartDate);
      let endMonth = moment(startDate).add(selectedMonth, "M");
      this.variableEndDate = endMonth.format("YYYY-MM-DD");

      // console.log(startDate.format("DD-MM-YYYY"));
      // console.log(endMonth.format("DD-MM-YYYY"));
    },
    addSalary() {
      this.submitted = true;
      this.salary.employeeId = this.employee.id
      this.salary.employee = this.employee
      this.salary.elementId = this.element.id
      this.salary.salaryElement = this.element
      this.salary.amount = parseFloat(this.amount)
      this.salary.variableStartDate = this.variableStartDate,
      this.salary.variableEndDate = this.variableEndDate,
      this.salary.thirteenMonth = false
      this.salaries.push(this.salary)
      console.log(this.salary)
      this.salary = {}
      this.element = {}
      this.employee = {}
      this.amount = 0
      this.month = ""
      this.variableStartDate = ""
      this.variableEndDate = ""
      this.submitted = false
    },
    onSubmit(recalculate) {
      this.submitted = true;
      this.loading = true;

      paymentService.addEmployeeSalaries(this.salaries, recalculate).then(
        id => {
          this.salaries = []
          this.closeDelete();
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    }
  },

  mounted() {
    this.getEmployees();
    this.getElements();
    // Datatable
    //this.getEmployees(this.employee.id);
    //this.getEmployeeResignations(this.company.id);

    if ($(".datatable").length > 0) {
      $(".datatable").DataTable({
        bFilter: false
      });
    }
    // Date Time Picker

    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "salary"
};
</script>



// WEBPACK FOOTER //
// src/components/payroll/manualpayitem.vue